import { z } from 'zod';

interface SchemaField {
	name: string;
	validation: z.ZodTypeAny;
}

export default function SchemaBuilder(schemaFields: SchemaField[]) {
	const SchemaObject: Record<string, z.ZodTypeAny> = {};

	schemaFields.forEach((field) => {
		SchemaObject[field.name] = field.validation;
	});

	return z.object(SchemaObject);
}
